import {Admin} from "./Admin"

export const AddAdminFormTemplate = Object.freeze({
    sections: [
        {
            size: 1/2,
            compact: true,
            inputs: [
                Admin.name,
                Admin.last_name,
                Admin.email,
                Admin.super,
                Admin.password,
                Admin.passwordVerification,
            ]
        },
    ]
});